export const APPLICATION_PAGE_SIZE = 50;

export const CARD_COUNT = 30;

export const FOCUS_APPLICATION_COUNT = 10;
